import FormattedList from 'I18n/components/FormattedList';
// @ts-expect-error untyped
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped
import { isError, isLoading } from 'reference-resolvers/utils';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error untyped
import { TASK_ASSOCIATION_CACHE_KEY } from '../../../reference-resolvers/TaskAssociatedObjectsReferenceResolver';
import AssociationAvatars from './AssociationAvatars';
import { getUILink } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function makeCellForAssociationType(associationCategoryId, associationTypeId) {
  const associationTypeKey = `${associationCategoryId}-${associationTypeId}`;
  function AssociationCell({
    resolvedAssociations
  }) {
    const associatedObjectsData = getIn(['referencedObject', 'associations', associationTypeKey], resolvedAssociations);
    const associatedObjects = get('associatedObjects', associatedObjectsData);
    if (isLoading(resolvedAssociations) || isError(resolvedAssociations) || !associatedObjects) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(AssociationAvatars, {
        associatedObjects: associatedObjects
      }), /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(FormattedList, {
          children: associatedObjects.map(getUILink)
        })
      })]
    });
  }
  const mapResolverToProps = (resolvers, props) => {
    return {
      resolvedAssociations: resolvers[TASK_ASSOCIATION_CACHE_KEY].byId(props.original.objectId)
    };
  };
  const ResolvedAssociationCell = ResolveReferences(mapResolverToProps)(AssociationCell);
  return ResolvedAssociationCell;
}